import { sexArr, ageGroup } from 'json/customer-options'
export let customerTableFilter = [
  {
    label: '所在地',
    type: 'select',
    clearable: true,
    filterable: true,
    value: 'city',
    options: []
  },
  {
    label: '业务来源',
    type: 'select',
    clearable: true,
    value: 'channel',
    props: {
      label: 'name',
      value: 'value'
    },
    options: []
  },
  {
    label: '年龄段',
    type: 'number-slot',
    clearable: true,
    minPlaceholder: '年龄',
    maxPlaceholder: '年龄',
    minName: 'ageStart',
    maxName: 'ageEnd',
    value: 'age'
  },
  {
    label: '性别',
    type: 'select',
    clearable: true,
    value: 'gender', // 需返回数据的字段名
    options: sexArr
  },
  {
    label: '选择时间',
    type: 'time-slot',
    clearable: true,
    startName: 'startDate',
    endName: 'endDate',
    value: 'registryTime'
  },
  {
    label: '用户类型',
    type: 'select',
    clearable: true,
    value: 'userLabel',
    options: [
      {
        label: '新注册用户',
        value: 'NEW_REGISTRY'
      },
      {
        label: '新家系用户',
        value: 'FAMILY_MEMBER'
      }
    ]
  },
  {
    label: '是否绑定CPS合同',
    type: 'select',
    clearable: true,
    value: 'bindCps',
    options: [
      {
        label: '是',
        value: 'true'
      },
      {
        label: '否',
        value: 'false'
      }
    ]
  },
  {
    label: '是否购买脐健康商品',
    value: 'qjkProductBuy',
    type: 'select',
    clearable: true,
    options: [
      {
        label: '是',
        value: 'true'
      },
      {
        label: '否',
        value: 'false'
      }
    ]
  },
  {
    label: '所属分子公司',
    value: 'businessBranchId',
    type: 'select',
    clearable: true,
    props: {
      label: 'fullName',
      value: 'id'
    },
    options: [
    ]
  }
]
// 导入用户列表label
export let importCustomerLabel = [
  {
    label: '姓名',
    value: 'name'
  },
  {
    label: '手机号',
    value: 'mobile'
  },
  {
    label: '金额（单位元）',
    value: 'money'
  },
  {
    label: '最近登录时间',
    value: 'last_modified_date',
    minWidth: 120
  }
]
// 用户列表公共label
export let customerLables = [
  {
    label: '姓名',
    value: 'fullName'
  },
  {
    label: '性别',
    value: 'gender'
  },
  {
    label: '生日',
    value: 'birthday_date'
  },
  {
    label: '手机号',
    value: 'mobile'
  },
  {
    label: '身份证号',
    value: 'idCard'
  },
  {
    label: '所在地',
    value: 'city'
  }
]
// 全部用户列表表格labels
export let userTableLabels = [
  ...customerLables,
  {
    label: '业务来源',
    value: 'sourceName'
  },
  {
    label: 'CPS所在地',
    value: 'businessInformation.city'
  },
  //   {
  //     label: '用户名',
  //     value: 'nickname'
  //   },
  {
    label: '已注册',
    value: 'is_registry'
  },
  {
    label: '注册时间',
    minWidth: 110,
    value: 'registry_time'
  },
  {
    label: '是否绑定CPS合同',
    minWidth: 120,
    value: 'isCPS'
  },
  {
    label: '当前等级',
    value: 'levelName_name'
  },
  {
    label: '等级变更时间',
    value: 'levelChangeTime_date',
    minWidth: 110
  }
]
// 基因检测用户列表表格labels
export let geneUserTableLabels = [
  ...customerLables,
  {
    label: '代理商',
    value: ''
  },
  {
    label: '所属区域',
    value: ''
  },
  {
    label: '购买人',
    value: ''
  },
  {
    label: '受检人',
    value: ''
  },
  {
    label: '已注册',
    value: 'is_registry'
  }
]
// 成人细胞存储用户列表表格labels
export let adultUserTableLabels = [
  ...customerLables,
  {
    label: '代理商',
    value: ''
  },
  {
    label: '所属区域',
    value: ''
  },
  {
    label: '生化检测',
    value: ''
  },
  {
    label: '已注册',
    value: 'is_registry'
  }
]
// 线上用户用户列表表格labels
export let onlineUserTableLabels = [
  ...customerLables,
  {
    label: '业务来源',
    value: 'sourceName'
  },
  {
    label: '已成单',
    value: ''
  }
]
// 选择用户label
export let couponUserListLabels = [
  {
    label: '姓名',
    value: 'fullName'
  },
  {
    label: '性别',
    value: 'gender'
  },
  {
    label: '生日',
    value: 'birthday_date'
  },
  {
    label: '手机号',
    value: 'mobile',
    minWidth: 120
  },
  {
    label: '业务来源',
    value: 'sourceName'
  },
  {
    label: '最近登录时间',
    value: 'last_login_time',
    minWidth: 140
  },
  {
    label: '地区',
    value: 'city'
  },
  {
    label: '是否绑定CPS合同',
    minWidth: 120,
    value: 'isCPS'
  },
  {
    label: '是否为家系用户',
    value: 'isFamily'
  },
  {
    label: '成为家系用户时间',
    value: 'family_date'
  }
]
export let filterFactorUser = [
  {
    label: '性别',
    type: 'select',
    clearable: true,
    value: 'gender', // 需返回数据的字段名
    options: sexArr
  },
  {
    label: '年龄段',
    type: 'select',
    clearable: true,
    value: 'age',
    options: ageGroup
  },
  {
    label: '地区',
    type: 'select',
    clearable: true,
    filterable: true,
    value: 'city',
    options: []
  },
  {
    label: '业务来源',
    type: 'select',
    clearable: true,
    value: 'channel',
    props: {
      label: 'name',
      value: 'value'
    },
    options: []
  },
  {
    label: '最近登录时间',
    type: 'time-slot',
    clearable: true,
    startName: 'lastLoginStartTime',
    endName: 'lastLoginEndTime',
    value: 'loginTime'
  },
  {
    label: '用户类型',
    type: 'select',
    clearable: true,
    value: 'userLabel',
    options: [
      {
        label: '新注册用户',
        value: 'NEW_REGISTRY'
      },
      {
        label: '新家系用户',
        value: 'FAMILY_MEMBER'
      }
    ]
  },
  {
    label: '是否绑定CPS合同',
    type: 'select',
    clearable: true,
    value: 'bindCps',
    options: [
      {
        label: '是',
        value: 'true'
      },
      {
        label: '否',
        value: 'false'
      }
    ]
  }
]
// 促销活动选择用户筛选条件
export let filterFactorUserPromotion = [
  {
    label: '用户角色',
    type: 'select',
    clearable: true,
    value: 'role',
    options: [
      {
        label: '咨询师',
        value: 'COUNSELOR_USER'
      },
      {
        label: '医生',
        value: 'DOCTOR_USER'
      }
    ]
  },
  {
    label: '性别',
    type: 'select',
    clearable: true,
    value: 'gender', // 需返回数据的字段名
    options: sexArr
  },
  {
    label: '地区',
    type: 'select',
    clearable: true,
    filterable: true,
    value: 'city',
    options: []
  },
  {
    label: '用户类型',
    type: 'select',
    clearable: true,
    value: 'userLabel',
    options: [
      {
        label: '新注册用户',
        value: 'NEW_REGISTRY'
      },
      {
        label: '新家系用户',
        value: 'FAMILY_MEMBER'
      }
    ]
  },
  {
    label: '业务来源',
    type: 'select',
    clearable: true,
    value: 'channel',
    props: {
      label: 'name',
      value: 'value'
    },
    options: []
  },
  {
    label: '年龄段',
    type: 'select',
    clearable: true,
    value: 'age',
    options: ageGroup
  },
  {
    label: '最近登录时间',
    type: 'time-slot',
    clearable: true,
    startName: 'lastLoginStartTime',
    endName: 'lastLoginEndTime',
    value: 'loginTime'
  },
  {
    label: '是否绑定CPS合同',
    type: 'select',
    clearable: true,
    value: 'bindCps',
    options: [
      {
        label: '是',
        value: 'true'
      },
      {
        label: '否',
        value: 'false'
      }
    ]
  }
]
export let filterFactorUserOrder = [
  {
    label: '已购商品',
    type: 'input',
    clearable: true,
    value: 'goodsName',
    placeholder: '请输入商品名称'
  },
  {
    label: '下单时间',
    type: 'time-slot',
    clearable: true,
    startName: 'paidTimeStart',
    endName: 'paidTimeEnd',
    value: 'mallOrder'
  }
]
export let companyUser = {
  label: '分子公司',
  value: 'branchCompanyId',
  type: 'select',
  clearable: true,
  options: [],
  props: {
    label: 'fullName',
    value: 'id'
  },
  class: 'branch-company-select'
}
export let cityForUser = {
  label: '地区',
  type: 'select',
  clearable: true,
  filterable: true,
  value: 'city',
  options: []
}
